module.exports = __webpack_public_path__ + "img/ic_empty-line.3e0442f8.svg";